var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "grcreport"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter fa-xs",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('receivedEmail.fromSender')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('receivedEmail.senderPlaceHolder')
    },
    model: {
      value: (_vm.emailsender),
      callback: function($$v) {
        _vm.emailsender = $$v
      },
      expression: "emailsender"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('receivedEmail.Subject')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('receivedEmail.SubjectPlaceHolder')
    },
    model: {
      value: (_vm.Subject),
      callback: function($$v) {
        _vm.Subject = $$v
      },
      expression: "Subject"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('receivedEmail.qc')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-plus-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.QCstatus),
      expression: "QCstatus"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('QCstatus')
    },
    attrs: {
      "name": "QCstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.QCstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('receivedEmail.qcPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accept"
    }
  }, [_vm._v(_vm._s(_vm.$t('receivedEmail.accept')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "reject"
    }
  }, [_vm._v(_vm._s(_vm.$t('receivedEmail.reject')))])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('inwardList.fromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.emailfromdate),
      callback: function($$v) {
        _vm.emailfromdate = $$v
      },
      expression: "emailfromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.toDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.emailtodate),
      callback: function($$v) {
        _vm.emailtodate = $$v
      },
      expression: "emailtodate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "300px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getReceviedEmailDataSearch(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('receivedEmail.ReceivedEmailDetails')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.EmailWMSID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.from')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.dateandTime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "15%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.Subject')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "15%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.AttachmentFileName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.qc')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.RejectReason')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.ResponseEmail')))])])])]), _vm._v(" "), _c('tbody', [(_vm.client == '' && _vm.warehouse == '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientandWarehouseHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client == '' && _vm.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.getRecords')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listReceviedEmailData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.useremail))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.dateFormatFRT2(data.emaildatetime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.emailsubject))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.excelfilename))]), _vm._v(" "), (data.operation == 'product' || data.operation == 'po') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.$t('receivedEmail.accept')) + "\n                ")]) : _vm._e(), (data.operation == 'invalid' || data.operation == 'invalid') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('receivedEmail.reject')) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.rejectreason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View Email Received Details"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getemailsdetails(data)
        }
      }
    })])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listReceviedEmailData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.addemailreceivedmodal = false
      }
    },
    model: {
      value: (_vm.addemailreceivedmodal),
      callback: function($$v) {
        _vm.addemailreceivedmodal = $$v
      },
      expression: "addemailreceivedmodal"
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("  " + _vm._s(_vm.$t('receivedEmail.ResponseEmailDetails')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeaddemailreceived
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "10px !important",
      "margin-bottom": "10px"
    }
  }, [_c('br'), _vm._v("\n               " + _vm._s(_vm.$t('receivedEmail.date')) + " : " + _vm._s(_vm.dateFormatFRT(this.emaildatetime)) + " "), _c('br'), _vm._v("\n               " + _vm._s(_vm.$t('receivedEmail.from')) + "  : alert@xpressbees.com "), _c('br'), _vm._v("\n               " + _vm._s(_vm.$t('receivedEmail.to')) + " : " + _vm._s(this.useremail) + " "), _c('br'), _vm._v("\n               " + _vm._s(_vm.$t('receivedEmail.Subject')) + " : " + _vm._s(_vm.Subjectedit) + " "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "border-style": "groove"
    }
  }, [_c('span', [_vm._v("Dear " + _vm._s(this.useremail) + ",")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("We received your email dated " + _vm._s(_vm.dateFormatFRT(this.createddatetime)) + " realted to " + _vm._s(this.actualSubject) + " .")]), _c('br'), _c('br'), _vm._v(" "), (_vm.operation != 'invalid') ? _c('span', [_vm._v("The Unique ID Assigned to your email is " + _vm._s(this.id) + " .")]) : _vm._e(), _c('br'), _c('br'), _vm._v(" "), (_vm.operation != 'invalid') ? _c('span', [_vm._v("Below are the request of the data upload request sent by you.")]) : _vm._e(), _c('br'), _c('br'), _vm._v(" "), (_vm.operation == 'invalid') ? _c('span', [_vm._v(_vm._s(_vm.errorMessage) + ".")]) : _vm._e(), _c('br'), _c('br'), _vm._v(" "), (_vm.operation != 'invalid') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-10",
    staticStyle: {
      "border-style": "groove",
      "margin-left": "2%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('receivedEmail.fileName')) + ": " + _vm._s(this.excelfilename))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('receivedEmail.dataType')) + ": " + _vm._s(this.operation))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('client.clientName')) + ": " + _vm._s(this.clientname))]), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "float": "right",
      "margin-left": "40px !important",
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('common.id')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('dataUploadLogs.totalRecords')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('dataUploadLogs.newRecords')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('dataUploadLogs.updatedRecords')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('dataUploadLogs.failedRecords')))])])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_c('strong', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.totalrecords))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.newreocrds))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.updatedrecords))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.faliedrecords))])])]), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.linkflag == true) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.linkflag == true) ? _c('div', {
    staticClass: "col-12"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('receivedEmail.downloadFile')) + "\n                    ")]), _c('br'), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": _vm.downloadlink,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.downloadBtn')))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('span', [_vm._v("Regards,\n                    ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                      Xpressbees Team\n                    ")])])])])])])], 1)])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2501dbf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2501dbf2","hasScoped":true}!./src/views/components/receivedemail/receivedemail.component.html
// module id = 1754
// module chunks = 0